globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Websites = appCustomerSpace.Controllers.Websites || {};

appCustomerSpace.Controllers.Websites.MainController = (function(superClass)
{
  utils.extend(MainController, superClass);

  function MainController() {
    return MainController.__super__.constructor.apply(this, arguments);
  }

  $.extend(MainController.prototype, {
    init: function() {
      $(".site-screenshot.request-screenshot").each(function() {
        appCustomerSpace.Modules.Websites.VersionScreenshot.request($(this));
      });

      var $popover = $("#connect-to-tool-popover");
      $popover.popover($popover.data('popover-options')).on('hidden.bs.popover', function(){
        return false;
      });

      setTimeout(function(){
        $popover.popover('show');
      }, 1000)

      return MainController.__super__.init.apply(this, arguments);
    }
  });

  return MainController;

})(appCustomerSpace.Controllers.MainController);
